module.exports = __webpack_public_path__ + "static/media/add.285bc265.svg";